import axios from "axios";
import { useToast } from "vue-toastification";
export default {
    namespaced: true,
    state: {
        dashboard: {
            home_page_slider_images: []
        },
        status: {
            home_page_slider_images: {
                loading: false,
                error: "",
            },
        },
    },
    getters: {
        getDashboard: (state) => state.dashboard,
        getStatus: (state) => state.status,
    },
    actions: {
        async fetchHomePageSliderImages({ commit }) {
            commit("setLoading", { dataName: "home_page_slider_images", status: true });
            const url = process.env.VUE_APP_API_URL + "/api/get-home-page-sliders";
            try {
                let { data } = await axios.get(url);
                commit("setHomePageSliderImages", data.payload);
                commit("setLoading", { dataName: "home_page_slider_images", status: false });
            } catch (error) {
                commit("setLoading", { dataName: "home_page_slider_images", status: false });
            }
        }
    },
    mutations: {
        setHomePageSliderImages: (state, payload) => {
            state.dashboard.home_page_slider_images = payload;
        },
        setLoading: (state, { dataName, status }) => {
            state.status[dataName].loading = status;
        },
        setError: (state, { dataName, error }) => {
            state.status[dataName].error = error;
        },
    },
};
